// removed by extract-text-webpack-plugin
module.exports = {"pageHeaderContainer":"pageHeaderContainer-3LWw-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/_pageHeader.css
// module id = 1281
// module chunks = 1